/*@ngInject*/
const UICalendarFocusDirective = function ($timeout) {

    let linkFunction = function ($scope, $elm, $attrs) {
        let timeoutList = [];

        timeoutList.push($timeout(function () {
            $scope.$broadcast('uib:datepicker.focus');
        }));

        $scope.$on('$destroy', function () {
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });
    };

    return {
        restrict: 'AC',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiCalendarFocus', UICalendarFocusDirective);
